import * as React from 'react';

import { ActivityStatus } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { TooltipV2 } from '~shared/components/TooltipV2';
import { ActiveIcon } from '~teacher/components/Header/ActivityStatusIcons/ActiveIcon';
import { InactiveIcon } from '~teacher/components/Header/ActivityStatusIcons/InactiveIcon';
import { PauseIcon } from '~teacher/components/Header/ActivityStatusIcons/PauseIcon';

export function ActivityStatusIcon({
  status,
  className,
}: {
  status: ActivityStatus;
  className?: string;
}) {
  return (
    <div className={className}>
      {(() => {
        if (status === ActivityStatus.Paused) {
          return (
            <TooltipV2 label={translate('Paused Activity')}>
              <PauseIcon className="text-green-700" />
            </TooltipV2>
          );
        } else if (status === ActivityStatus.Running) {
          return (
            <TooltipV2 label={translate('Live Activity')}>
              <ActiveIcon className="text-green-700" size="standard" />
            </TooltipV2>
          );
        } else {
          return (
            <TooltipV2 label={translate('No Activity')}>
              <InactiveIcon className="text-grey-500" size="standard" />
            </TooltipV2>
          );
        }
      })()}
    </div>
  );
}
